import { useTranslation } from 'react-i18next';
import {
  FormContainerWithHeader,
  PaperLayout,
} from '../../../../../presentation';
import './policy.overview.subjectivity-list.scss';

export const SubjectivityListFormSection = () => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'entities.policy.detail.content.sections.overview.subjectivityList',
        'Subjectivity list'
      )}
    >
      <PaperLayout className="subjectivity-list-form-section-layout">
        <p>To be Implemented</p>
      </PaperLayout>
    </FormContainerWithHeader>
  );
};
